import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faDownload } from '@fortawesome/pro-light-svg-icons';

interface IPdfActionIconButtonsProps {
  isPdf: boolean;
  disabled?: boolean;
  onOpen: () => void;
  onDownload: () => void;
}

export function PdfActionIconButtons({ isPdf, disabled, onOpen, onDownload }: Readonly<IPdfActionIconButtonsProps>) {
  const downloadLabel = isPdf ? 'Download PDF' : 'Download fil';

  function handle(action: () => void) {
    return (event: React.MouseEvent) => {
      // The row has its own click action, which must not run as well.
      event.stopPropagation();
      action();
    };
  }

  return (
    <Box display="flex" gap={0.5}>
      {isPdf && (
        <Tooltip title="Åbn PDF i ny fane">
          <span>
            <IconButton size="small" aria-label="Åbn PDF i ny fane" disabled={disabled} onClick={handle(onOpen)}>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <Tooltip title={downloadLabel}>
        <span>
          <IconButton size="small" aria-label={downloadLabel} disabled={disabled} onClick={handle(onDownload)}>
            <FontAwesomeIcon icon={faDownload} size="xs" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
